import { render, staticRenderFns } from "./employers.vue?vue&type=template&id=60e3b694&scoped=true&"
import script from "./employers.vue?vue&type=script&lang=js&"
export * from "./employers.vue?vue&type=script&lang=js&"
import style0 from "./employers.vue?vue&type=style&index=0&id=60e3b694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3b694",
  null
  
)

export default component.exports